import React, { Component } from "react";
import { Route } from "react-router-dom";

import Header from "./common/Header";
import Footer from "./common/Footer";

import Inicio from "./inicio/Inicio";
import CadastroEmpresa from "./empresa/CadastroEmpresa";
import ConsultaEmpresa from "./empresa/ConsultaEmpresa";
import CadastroUsuario from "./usuario/CadastroUsuario";
import ConsultaUsuario from "./usuario/ConsultaUsuario";
import ConsultaUsuarioLog from "./usuario/ConsultaUsuarioLog";
import CadastroProcedimento from "./procedimento/CadastroProcedimento";
import ConsultaProcedimento from "./procedimento/ConsultaProcedimento";
import CadastroPaciente from "./paciente/CadastroPaciente";
import ConsultaPaciente from "./paciente/ConsultaPaciente";
import Prontuario from "./prontuario/Prontuario";
import CadastroAtendimento from "./atendimento/CadastroAtendimento";
import ConsultaAtendimento from "./atendimento/ConsultaAtendimento";
import CadastroReuniao from "./reuniao/CadastroReuniao";
import ConsultaReuniao from "./reuniao/ConsultaReuniao";
import Importacao from "./importacao/Importacao";
import Apuracao from "./relatorio/Apuracao";
import Producao from "./relatorio/Producao";
import AuditoriaAtendimento from "./atendimento/auditoria/AuditoriaAtendimento";
import AuditoriaReuniao from "./reuniao/auditoria/AuditoriaReuniao";
import AuditoriaProcedimento from "./procedimento/auditoria/AuditoriaProcedimento";
import CadastroCategoria from "../financeiro/CadastroCategoria";
import ConsultaCategoria from "../financeiro/ConsultaCategoria";
import CadastroLancamento from "../financeiro/CadastroLancamento";
import ConsultaLancamento from "../financeiro/ConsultaLancamento";

class Main extends Component {
  constructor(props) {
    super(props);
    this.handleEmular = this.handleEmular.bind(this);
  }

  handleEmular(emulacao) {
    let usuario = this.props.usuario;
    if (emulacao) {
      usuario = emulacao.usuario;
      usuario.emulado = true;
      localStorage.setItem("emulado_accessToken", emulacao.accessToken);
    }
    this.props.onUpdateUsuario(usuario);
  }

  render() {
    return (
      <div className="container-scroller">
        <Header usuario={this.props.usuario} />
        <div className="container-fluid page-body-wrapper">
          <div className="main-panel">
            <div className="content-wrapper">
              <Route
                exact
                path="/"
                render={() => <Inicio usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/inicio"
                render={() => <Inicio usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/inicio_teste"
                render={() => <Inicio usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/empresa/cadastro/:id"
                render={({ match }) => (
                  <CadastroEmpresa
                    match={match}
                    onUpdate={this.props.onUpdateEmpresa}
                  />
                )}
              />
              <Route
                exact
                path="/empresa/cadastro"
                component={CadastroEmpresa}
              />
              <Route
                exact
                path="/empresa/consulta"
                component={ConsultaEmpresa}
              />
              <Route
                exact
                path="/usuario/cadastro/:id"
                render={({ match }) => (
                  <CadastroUsuario
                    usuario={this.props.usuario}
                    match={match}
                    onUpdate={this.props.onUpdateUsuario}
                  />
                )}
              />
              <Route
                exact
                path="/usuario/cadastro"
                render={() => (
                  <CadastroUsuario
                    usuario={this.props.usuario}
                    onUpdate={this.props.onUpdateUsuario}
                  />
                )}
              />
              <Route
                exact
                path="/usuario/consulta"
                render={() => (
                  <ConsultaUsuario
                    usuario={this.props.usuario}
                    onEmular={this.handleEmular}
                  />
                )}
              />
              <Route
                exact
                path="/usuario/logs"
                component={ConsultaUsuarioLog}
              />
              <Route
                exact
                path="/procedimento/auditoria/:id"
                render={({ match }) => (
                  <AuditoriaProcedimento
                    usuario={this.props.usuario}
                    match={match}
                  />
                )}
              />
              <Route
                exact
                path="/procedimento/cadastro/:id"
                component={CadastroProcedimento}
              />
              <Route
                exact
                path="/procedimento/cadastro"
                component={CadastroProcedimento}
              />
              <Route
                exact
                path="/procedimento/consulta"
                component={ConsultaProcedimento}
              />
              <Route
                exact
                path="/paciente/cadastro/:id"
                component={CadastroPaciente}
              />
              <Route
                exact
                path="/paciente/cadastro"
                component={CadastroPaciente}
              />
              <Route
                exact
                path="/paciente/consulta"
                component={ConsultaPaciente}
              />
              <Route
                exact
                path="/paciente/prontuario/:id"
                render={({ match }) => (
                  <Prontuario usuario={this.props.usuario} match={match} />
                )}
              />
              <Route
                exact
                path="/atendimento/auditoria/:id"
                render={({ match }) => (
                  <AuditoriaAtendimento
                    usuario={this.props.usuario}
                    match={match}
                  />
                )}
              />
              <Route
                exact
                path="/atendimento/cadastro/:id"
                render={({ match }) => (
                  <CadastroAtendimento
                    usuario={this.props.usuario}
                    match={match}
                  />
                )}
              />
              <Route
                exact
                path="/atendimento/cadastro"
                render={() => (
                  <CadastroAtendimento usuario={this.props.usuario} />
                )}
              />
              <Route
                exact
                path="/atendimento/consulta"
                render={() => (
                  <ConsultaAtendimento usuario={this.props.usuario} />
                )}
              />
              <Route
                exact
                path="/reuniao/auditoria/:id"
                render={({ match }) => (
                  <AuditoriaReuniao
                    usuario={this.props.usuario}
                    match={match}
                  />
                )}
              />
              <Route
                exact
                path="/reuniao/cadastro/:id"
                render={({ match }) => (
                  <CadastroReuniao usuario={this.props.usuario} match={match} />
                )}
              />
              <Route
                exact
                path="/reuniao/cadastro"
                render={() => <CadastroReuniao usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/reuniao/consulta"
                render={() => <ConsultaReuniao usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/producao/importacao"
                render={() => <Importacao usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/relatorio/apuracao"
                render={() => <Apuracao usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/relatorio/producao"
                render={() => <Producao usuario={this.props.usuario} />}
              />
              <Route
                exact
                path="/financeiro/cadastro/:id"
                render={({ match }) => (
                  <CadastroCategoria
                    usuario={this.props.usuario}
                    match={match}
                  />
                )}
              />
              <Route
                exact
                path="/financeiro/cadastro"
                render={() => (
                  <CadastroCategoria usuario={this.props.usuario} />
                )}
              />
              <Route
                exact
                path="/financeiro/consulta"
                render={() => (
                  <ConsultaCategoria usuario={this.props.usuario} />
                )}
              />
              <Route
                exact
                path="/financeiro/lancamento/cadastro/:id"
                render={({ match }) => (
                  <CadastroLancamento
                    usuario={this.props.usuario}
                    match={match}
                  />
                )}
              />
              <Route
                exact
                path="/financeiro/lancamento/cadastro"
                render={() => (
                  <CadastroLancamento usuario={this.props.usuario} />
                )}
              />
              <Route
                exact
                path="/financeiro/lancamento/consulta"
                render={() => (
                  <ConsultaLancamento usuario={this.props.usuario} />
                )}
              />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default Main;
